/* eslint-disable react/jsx-no-undef */
import React from 'react';
import  { UncontrolledTooltip, Input } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';

import { cfPath } from '../../../utilities/UrlPaths';

const formatChannel = (channelText) => {
  let abbreviation = 'INV';
  if (channelText.trim().indexOf('Infinite Bidding') > -1 || channelText.trim().indexOf('Connect') > -1) {
    abbreviation = 'PL';
  } else if (channelText.trim() === 'AuctionZip') {
    abbreviation = 'AZ';
  }

  return abbreviation;
};

const AutoChargeTableCols = (
  showNewDates,
  selectedDate,
  formatDate,
  handleOnChangeInvoiceChecked,
  handleOnCheckedAllInvoices,
  isEveryInvoiceChecked,
  acInvoiceIdArray
) => {
  const tableColumns = [
    {
      Header: (
        <span className="ml-4 pl-2">
          <Input
            type="checkbox"
            onChange={() => handleOnCheckedAllInvoices()}
            checked={isEveryInvoiceChecked}
            className="cursor-pointer"
          />
        </span>
        ),
      headerClassName: 'd-flex align-items-center',
      id: 'checkbox',
      className: 'wrap-table-cell',
      minWidth: 25,
      sortable: false,
      accessor: d => d,
      Cell: ({ value: { invoiceID } }) => {
        if (!invoiceID) {
          return null;
        }

        return  (
          <div className="ml-4">
            <Input
              type="checkbox"
              key={Math.random()}
              onClick={(e) => handleOnChangeInvoiceChecked(e)}
              defaultChecked={acInvoiceIdArray.indexOf(invoiceID) > -1}
              className="cursor-pointer"
              value={invoiceID}
            />
          </div>
        )

      }
    },
    {
      Header: (<div>Invoice # <FontAwesomeIcon className="ml-1 not-small" icon="sort" /></div>),
      headerClassName: 'd-flex align-items-center',
      id: 'invoice',
      className: 'wrap-table-cell',
      minWidth: 58,
      sortable: true,
      accessor: d => d,
      sortMethod: (a, b) => {
        const aValue = (!Number.isNaN(Number(a.invoiceID))) ? Number(a.invoiceID) : 0;
        const bValue = (!Number.isNaN(Number(b.invoiceID))) ? Number(b.invoiceID) : 0;
        if (aValue === bValue) return 0;
        return (aValue > bValue) ? 1 : -1;
      },
      Cell: ({ value: { invoiceID } }) => {
        if (!invoiceID) {
          return null;
        }

        return  invoiceID;

      }
    },
    {
      Header: (<div>Name <FontAwesomeIcon className="ml-1 not-small" icon="sort" /></div>),
      headerClassName: 'd-flex align-items-center',
      id: 'lastname',
      className: 'wrap-table-cell',
      minWidth: 165,
      sortable: true,
      accessor: d => d,
      sortMethod: (a, b) => {
        const aValue = (a.lastName.length) ? a.lastName.toLowerCase() : '';
        const bValue = (b.lastName.length) ? b.lastName.toLowerCase() : '';
        if (aValue === bValue) return 0;
        return (aValue > bValue) ? 1 : -1;
      },
      Cell: ({ value: { lastName, firstName, approvalID, channel } }) => {
        if (!lastName) {
          return null;
        }

        let displayName = `${lastName}, ${firstName}`;
        const hoverName = displayName;
        let showTooltip = false;
        if (displayName.length > 25) {
          displayName = `${displayName.substring(0, 22)}...`;
        }

        return (
          <>
            <div id={`hover_${approvalID}`}>
              <a href={`${cfPath()}/al/bidders/viewBidder.cfm?approvalID=${approvalID}`} target="_blank" rel="noopener noreferrer">
                {displayName}
              </a>
              <span> | {formatChannel(channel)}</span>
            </div>
            {showTooltip && (
            <UncontrolledTooltip placement="right" target={`hover_${approvalID}`} className="name-tooltip other-tooltip">
              {hoverName}
            </UncontrolledTooltip>
            )}
          </>
        );
      }
    },
    {
      Header: (<div>Invoice Total <FontAwesomeIcon className="ml-1 not-small" icon="sort" /></div>),
      headerClassName: 'd-flex align-items-center',
      id: 'total',
      className: 'wrap-table-cell',
      minWidth: 80,
      sortable: true,
      accessor: d => d,
      sortMethod: (rowA, rowB) => {
        const a = parseFloat(rowA.invoiceTotal.replaceAll(',', ''));
        const b = parseFloat(rowB.invoiceTotal.replaceAll(',', ''));
        return a > b ? 1 : -1;
      },
      Cell: ({ value: { invoiceTotal, currencySymbol } }) => {
        if (!invoiceTotal) {
          return null;
        }

        return (

          <div>
            <div className="float-left">
              {currencySymbol}
            </div>
            <div className="float-right mr-2">
              { invoiceTotal }
            </div>
          </div>
        );
      }
    },
    {
      Header: (<div>Eligible Amt. <FontAwesomeIcon className="ml-1 not-small" icon="sort" /></div>),
      headerClassName: 'd-flex align-items-center',
      id: 'eligible',
      className: 'wrap-table-cell',
      minWidth: 80,
      sortable: true,
      accessor: d => d,
      sortMethod: (rowA, rowB) => {
        const a = parseFloat(rowA.eligibleAmount.replaceAll(',', ''));
        const b = parseFloat(rowB.eligibleAmount.replaceAll(',', ''));
        return a > b ? 1 : -1;
      },
      Cell: ({ value: { eligibleAmount, currencySymbol } }) => {
        if (!eligibleAmount) {
          return null;
        }

        return (

          <div>
            <div className="float-left">
              {currencySymbol}
            </div>
            <div className="float-right mr-2">
              { eligibleAmount }
            </div>
          </div>
        );
      }
    },
    {
      Header: (<div>Auto-Charge Date <FontAwesomeIcon className="ml-1 not-small" icon="sort" /></div>),
      headerClassName: 'd-flex align-items-center',
      id: 'total',
      className: 'wrap-table-cell float-left',
      minWidth: 90,
      sortable: true,
      accessor: d => d,
      sortMethod: (a, b) => {
        const aValue = (!Number.isNaN(Number(a.autoChargeDate))) ? Number(a.autoChargeDate) : 0;
        const bValue = (!Number.isNaN(Number(b.autoChargeDate))) ? Number(b.autoChargeDate) : 0;
        if (aValue === bValue) return 0;
        return (aValue > bValue) ? 1 : -1;
      },
      Cell: ({ value: { autoChargeDate, invoiceID, invalidDateCSS } }) => {
        return (

          <div>
            <div id={`invalid_${invoiceID}`} className={showNewDates && acInvoiceIdArray.indexOf(invoiceID) > -1 ? 'bolt-green' : invalidDateCSS}>
              {showNewDates && acInvoiceIdArray.indexOf(invoiceID) > -1 && formatDate(selectedDate)}
              {!showNewDates && autoChargeDate > 0 && formatDate(new Date(autoChargeDate))}
              {showNewDates && acInvoiceIdArray.indexOf(invoiceID) === -1 && autoChargeDate > 0 && formatDate(new Date(autoChargeDate))}
              {invalidDateCSS !== '' && (
                <FontAwesomeIcon icon={faQuestionCircle} color="black" className="ml-2" />
              )}
            </div>
            {invalidDateCSS !== '' && (
              <UncontrolledTooltip placement="right" target={`invalid_${invoiceID}`} className="name-tooltip other-tooltip">
                This auto-charge date is no longer valid. Please select a date 48 hours from last edit            
              </UncontrolledTooltip>
            )}
          </div>
        );
      }
    }
  ];

  
  return tableColumns;
};

export default AutoChargeTableCols;
